<template>
  <div>
    <div class="wrapper">
      <div class="input">
        <!-- <span class="selectedK" ref="selectedK" v-if="keywords && showTag"><span class="close" @click="hide()">×</span>{{keywords}}</span> -->
        <!-- <input type="search" name="" id="" v-model="k" @search="slicew" @keyup.delete="deleteSpan()" :placeholder="spanWidth?'':'输入领域或者关键词，查看相关主题'" class="search-input" :style="{'paddingLeft': (spanWidth + 24) + 'px'}"> -->
        <input type="search" name="" id="" v-model="k" @search="slicew" :placeholder="$store.state.screen==='pc'?'输入领域或者关键词，查看相关主题':'输入领域或者关键词'" class="search-input">
      </div>
      <div class="btn" @click="slicew">搜索一下</div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isInput: false
    }
  },
  components: {},
  props: ['kwd', 'tags', 'id'],
  methods: {
    slicew () {
      // 导航
      // this.$router.replace({ path: 'search', query: { k: this.id ? this.k : this.kk } })
      this.$router.replace({ path: 'search', query: { k: this.isInput ? this.kk : this.k } }, () => {})
      this.isInput = false
    }
  },
  computed: {
    k: {
      get: function () {
        if (this.id) {
          // this.kk = this.tags[this.id] && this.tags[this.id].name
          return this.tags[this.id] && this.tags[this.id].name
        } else {
          return this.kwd
        }
      },
      set: function (n) {
        this.isInput = true
        this.kk = n
      }
    }
  }
}
</script>
<style scoped lang='sass'>

.wrapper
  display: flex
  align-items: stretch
  .input
    position: relative
    .selectedK
      position: absolute
      top: 50%
      transform: translateY(-50%)
      left: 15px
      font-size: 12px
      color: #657180
      padding: 2px 18px 2px 10px
      background-color: #f7f7f7
      border: 1px solid #e3e8ee
      border-radius: 6px
    .search-input
      box-sizing: border-box
      -webkit-appearance: none
      -webkit-box-sizing: border-box
      -webkit-border-radius: 0px
      -moz-box-sizing: border-box
      border: 1px solid #d9d9d9
      outline: none
      width: 380px
      height: 40px
      font-size: 16px
      padding-left: 15px
      +mobile
        width: 49vw
      &::-webkit-input-placeholder
        color: #d9d9d9
        font-size: 14px
      &::-webkit-search-cancel-button
        display: none
  .btn
    display: block
    background-color: var(--primary-color)
    color: #fff
    padding: 8px 20px
    cursor: pointer
</style>
